import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { Textarea } from 'components/ui/textarea';

/** Mirrors `MAX_AI_IMAGE_DESCRIPTION_CHARS` in the API's question DTO. */
export const MAX_AI_IMAGE_DESCRIPTION_CHARS = 2000;

interface Props {
  value: string;
  onChange: (value: string) => void;
}

/**
 * What the question's picture shows, in words. Candidates never see it: the AI uses it to explain
 * the answer when a candidate taps "AI tahlil", because the model cannot look at the picture.
 */
export const AiImageDescriptionField: React.FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation();
  const id = useId();
  return (
    <div className="space-y-1.5">
      <label
        htmlFor={id}
        className="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground"
      >
        {t('ai_image_description')}
      </label>
      <Textarea
        id={id}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        maxLength={MAX_AI_IMAGE_DESCRIPTION_CHARS}
        rows={2}
        placeholder={t('ai_image_description_placeholder')}
      />
      <p className="text-xs text-muted-foreground">{t('ai_image_description_hint')}</p>
    </div>
  );
};

export default AiImageDescriptionField;
